import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { LazyLoadEvent, Message } from 'primeng//api';
import { Subject, takeUntil } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'ness-certify-users',
  templateUrl: './certify-users.component.html'
})
export class CertifyUsersComponent implements OnDestroy, OnInit {
  cols: any[] = [
    { field: 'FirstName', header: 'First Name' },
    { field: 'LastName', header: 'Last Name' },
    { field: 'CertificationYear', header: 'Year' },
    { field: 'CertificationComment', header: 'Comment' }
  ];
  currentUserInfo: ServerModels.UserInfoViewModel;
  findDenyCertificationMessages: Message[] = [];
  loading: boolean = false;
  rows: number = AppConstants.defaultTableRows;
  selectedUsers: ServerModels.UserCertificationViewModel[] = [];
  usersToCertify: ServerModels.UserCertificationViewModel[] = [];

  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private adminService: AdminService,
    private loginService: LoginService,
    public elementRef: ElementRef) { }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  ngOnInit() {
    this.getUserCertifications();
    this.loginService.userInfoData$.pipe(takeUntil(this._unsubscribe$)).subscribe((userInfo: ServerModels.UserInfoViewModel) => this.currentUserInfo = userInfo);
  }

  public certifyUsers(): void {
    if (!!this.selectedUsers.length) {
      this.findDenyCertificationMessages = [];
      let usersToCertify: ServerModels.ENESS_UserAccountCertification[] = this.getUserAccountCertifications('Approved');
      this.loading = true;
      this.adminService.userAccountCertification(usersToCertify)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe((result: ServerModels.UserCertificationViewModel[]) => {
          this.selectedUsers = [];
          this.usersToCertify = [...result];
          this.refreshUserList();
          this.loading = false;
        });
    }
  }

  public denyCertifyUsers(): void {
    this.findDenyCertificationMessages = [];
    if (!!this.selectedUsers.length) {
      let usersToDeny: ServerModels.ENESS_UserAccountCertification[] = this.getUserAccountCertifications('Denied');
      let blankComments = 0;
      usersToDeny.forEach(x => {
        if (x.Comment === null || x.Comment.trim() === '') {
          blankComments += 1;
        }
      })
      if (blankComments > 0) {
        this.findDenyCertificationMessages.push({ severity: 'error', summary: 'Validation Message', detail: 'Comment required to deny certification.' });
      }
      else {
        this.findDenyCertificationMessages = [];
        this.loading = true;
        this.adminService.userAccountCertification(usersToDeny)
          .pipe(takeUntil(this._unsubscribe$))
          .subscribe((result: ServerModels.UserCertificationViewModel[]) => {
            this.selectedUsers = [];
            this.usersToCertify = [...result];
            this.refreshUserList();
            this.loading = false;
          }
        );
      }
    }
  }

  public refreshUserList(): void {
    const lazyLoadEvent: LazyLoadEvent = { "first": 0, "rows": 20, "sortOrder": 1, "filters": {}, "globalFilter": null };

    this.adminService.loadUsersList(lazyLoadEvent);
  }

  private getUserAccountCertifications(status: string): ServerModels.ENESS_UserAccountCertification[] {
    return this.selectedUsers.map(x => {
      return {
        UserAccountCertificationID: null,
        Year: x.CertificationYear,
        Status: status,
        CertifiedByUserId: this.currentUserInfo == null ? null : this.currentUserInfo.Id,
        UserAccountId: x.UserId,
        CertificationDate: new Date(),
        Comment: x.CertificationComment
      } as ServerModels.ENESS_UserAccountCertification
    });
  }

  private getUserCertifications(): void {
    this.selectedUsers = [];
    this.loading = true;
    this.adminService.getUncertifiedUsers().pipe(takeUntil(this._unsubscribe$)).subscribe((data: ServerModels.UserCertificationViewModel[]) => {
        this.loading = false;
        this.usersToCertify = [...data];
      },
      (err:any) => this.loading = false
    );
  }

  public clearErrorList(): void {
    this.findDenyCertificationMessages = [];
  }
}
